import { RolesInvUnidadDTO } from "./Usuarios/RolPersonaUnidadDTO"

export interface DataUsuarios{
    rowsPerPage: Array<number>
}

export interface UsuarioRol{
    iddecinvuser: number,
    identificacion: string,
    usuario: string,
    nombres: string,
    rolprincipal: string,
    rolessecundarios: Array<Rolsecundario>,
    unidad: string,
    autorizado: string,
    hindex: string,
    orcid: string,
    scholarid: string,
    scopusid: string,
}

export interface Rolsecundario{
    idrol: number,
    rol: string
}

export interface User{
    iddecinvuser: number,
    idpersona: number,
    identificacion: string,
    email: string,
    orcid: string,
    hindex: string,
    scopusid: string,
    scholarid: string
}

export interface Guardaruser{
    user : User,
    roles: Array<RolesInvUnidadDTO>
}

export function getUserEmpty(): User{
    return{
        iddecinvuser: 0,
        idpersona: 0,
        identificacion: '',
        email: '',
        orcid: '',
        hindex: '',
        scopusid: '',
        scholarid: ''
    }
}

export function getUserEmptyRol(): UsuarioRol{
    return{
        iddecinvuser: 0,
        identificacion: '',
        usuario: '',
        nombres: '',
        rolprincipal: '',
        rolessecundarios:[],
        unidad: '',
        autorizado: '',
        hindex: '',
        orcid: '',
        scholarid: '',
        scopusid: '',
    }
}

export function getUsuarioVacio(): Guardaruser{
    return{
        user: getUserEmpty(),
        roles: []
    }
}
